import { css, styled } from 'canoe';
import React from 'react';

import { Shortcuts } from 'craft/components/Shortcuts';

const Container = styled.div<any>`
  ${({ enabled, theme }) => css`
    height: 2.5em;
    padding: 0.5em;
    margin: 0.2em;
    border-radius: 0.25em;

    display: flex;
    align-items: center;

    ${enabled
      ? css`
          color: ${theme.colors.White};
          &:hover {
            cursor: pointer;
            background-color: ${theme.colors.OnyxGrayL20};
          }
        `
      : css`
          color: ${theme.colors.OnyxGrayL20};
          pointer-events: none;
        `}
  `}
`;

interface Props {
  icon: React.ReactNode;
  children: React.ReactNode;
  shortcuts?: string[];
  onClick: (e: any) => any;
  enabled?: boolean;
}

export const MenuItem = ({ enabled, icon, children, shortcuts, onClick }: Props) => (
  <Container onClick={onClick} enabled={enabled}>
    <div css={{ marginRight: '0.5em' }}>{icon}</div>
    <div css={{ width: '100%' }}>{children}</div>
    {shortcuts && <Shortcuts keys={shortcuts} enabled={enabled} />}
  </Container>
);
